import { render, staticRenderFns } from "./passengers-info.vue?vue&type=template&id=093cb388&scoped=true"
import script from "./passengers-info.vue?vue&type=script&lang=js"
export * from "./passengers-info.vue?vue&type=script&lang=js"
import style0 from "./passengers-info.vue?vue&type=style&index=0&id=093cb388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093cb388",
  null
  
)

export default component.exports